import { ParagraphProps } from '../../../components/PageBuilder/Paragraph/Paragraph';
import WhatISImage from '../../../assets/images/unique/PlateletRichPlasma/blood.jpg';

export const PlateletRichPlasmaParagraphs: ParagraphProps[] = [
  {
    title: 'What it consists of',
    text: `Platelet-rich plasma is discussed in regenerative medicine because platelets carry growth factors involved in normal repair signaling. The topic is usually framed around how the body responds to irritation, injury, recovery demands, and tissue health.`,
    img: WhatISImage,
  },
  {
    title: 'What it may help discuss',
    text: `This subject may come up in conversations about musculoskeletal discomfort, mobility limitations, tendon or joint irritation, skin quality, or recovery after certain injuries. The useful question is not only what hurts, but why the tissue is irritated and what else may be affecting recovery.`,
  },
  {
    title: 'What is reviewed before deciding',
    text: `Evaluation may include symptom location, timeline, imaging when relevant, previous injuries, medication use, activity level, inflammation, and overall health. Before discussing any procedure, it is important to clarify diagnosis, alternatives, aftercare, and expected follow-up.`,
  },
  {
    title: 'What to keep in mind',
    text: `Regenerative language can sound promising, but outcomes depend on the condition, severity, technique, aftercare, and patient factors. Helpful questions include what is known, what is uncertain, what alternatives exist, and what signs would suggest a different diagnosis.`,
  },
];
